export enum FeeName_Enum {
  Undefined = 0,
  Fee = 1,
  Arrangement = 2,
  Acceptance = 3,
  CreditAcceptanceA = 4,
  CreditAcceptanceB = 5,
  CreditFacility = 6,
  Document = 7,
  OptionToPurchase = 8
}
